import React from 'react'

const PlusIcon14pxSvg = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none"><path d="M7 1.75a0.656 0.656 0 0 1 0.656 0.656v3.938h3.938a0.656 0.656 0 1 1 0 1.313h-3.938v3.938a0.656 0.656 0 1 1 -1.313 0v-3.938h-3.938a0.656 0.656 0 0 1 0 -1.313h3.938v-3.938A0.656 0.656 0 0 1 7 1.75" fill="white"/></svg>
    )
}

export default PlusIcon14pxSvg